/**
 * Server errors arrive in two shapes: the standard envelope
 * `{ success:false, error:<CODE>, message:<sentence> }` and the UMS
 * credit-refusal passthrough `{ error: { code, message, required, balance } }`
 * (402/403). The sentence is preferred wherever it sits; a string `error` is
 * read only when there is no `message` (older endpoints put the sentence
 * there), so a refusal code never shows in place of its explanation.
 *
 * `BaseClient` runs this on every rejected response and puts the result on
 * `error.message`, so a plain `catch (err) { setError(err.message) }` already
 * shows the server's sentence; call this directly when a fallback is needed.
 */
export const apiErrorMessage = (error: any, fallback: string): string => {
  const data = error?.response?.data;
  return (
    data?.error?.message ||
    data?.message ||
    (typeof data?.error === 'string' ? data.error : null) ||
    error?.message ||
    fallback
  );
};
